<div class="upper-part">
  <p class="flexFont" [ngStyle]="{ 'font-size.vw': fontSize }">
    <b>{{ displayMessage }}</b>
  </p>
</div>
